/**
 * Sélecteur de semaine centré au-dessus de la grille (SPEC PL1, P1) : libellé « SEMAINE », flèches rondes, plage
 * « 5 oct. — 11 oct. » ; précédente désactivée sur la semaine courante, pas de limite en avant (comme la v1).
 * Plus de légende des marques (retours du 07/10 : une seule marque est affichée à la fois ; son nom reste sur chaque
 * carte) ; les deux côtés vides gardent la semaine centrée.
 */
import { IconLeft, IconRight } from './icons';

interface WeekBarProps {
  rangeLabel: string;
  canGoBack: boolean;
  onPrevious: () => void;
  onNext: () => void;
}

export function WeekBar({ rangeLabel, canGoBack, onPrevious, onNext }: WeekBarProps) {
  return (
    <div className="mmv2-weekbar">
      <div className="mmv2-weekbar__side" />
      <div className="mmv2-week" role="group" aria-labelledby="mmv2-week-label">
        <span className="mmv2-week__label" id="mmv2-week-label">
          Semaine
        </span>
        <div className="mmv2-week__nav">
          <button
            type="button"
            className="mmv2-iconbtn"
            aria-label="Semaine précédente"
            disabled={!canGoBack}
            onClick={onPrevious}
          >
            <IconLeft />
          </button>
          <b className="mmv2-week__range" aria-live="polite">
            {rangeLabel}
          </b>
          <button type="button" className="mmv2-iconbtn" aria-label="Semaine suivante" onClick={onNext}>
            <IconRight />
          </button>
        </div>
      </div>
      <div className="mmv2-weekbar__side mmv2-weekbar__side--end" />
    </div>
  );
}
